module.exports = __webpack_public_path__ + "static/img/EN2.a654f5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/EN2.jpg
// module id = 59Rr
// module chunks = 1